import * as React from 'react';
import { useRouter } from 'next/navigation';
import { LinkButton } from '@/shared/components/button';
import { buildQaTrackingEntityProps } from '@/shared/modules/qa-tracking-entity';
import * as Styled from './my-library-card.styled';
interface MyLibraryCardProps {
  image: Edge.Image;
  title: string;
  buttonUrl: string;
  buttonText: string;
  gameId: string;
}
const CARD_IMAGE_WIDTH = 1080;
const CARD_IMAGE_HEIGHT = 463;
export const MyLibraryCard = React.memo(function MyLibraryCard({
  image,
  title,
  buttonText,
  buttonUrl,
  gameId
}: MyLibraryCardProps) {
  const router = useRouter();
  const prefetchGameplaySegment = React.useCallback(() => {
    router.prefetch(buttonUrl);
  }, [router, buttonUrl]);
  return <Styled.Wrapper {...buildQaTrackingEntityProps('newProfile.myLibrary.gameCard', {
    payload: gameId
  })}>
      <Styled.ImageWrapper>
        <Styled.Image loading="lazy" src={image.src} placeholder="empty" alt={image.alt || title} width={CARD_IMAGE_WIDTH} height={CARD_IMAGE_HEIGHT} />
      </Styled.ImageWrapper>

      <Styled.BottomContent>
        <Styled.CardTitle>{title}</Styled.CardTitle>
        <LinkButton size="m" color="primary" href={buttonUrl} prefetch={false} onMouseEnter={prefetchGameplaySegment}>
          {buttonText}
        </LinkButton>
      </Styled.BottomContent>
    </Styled.Wrapper>;
});